<!-- 页面布局（顶部、内容、底部） 顶部页
点击导航菜单，调用loadModule切换内容页
-->
<template>
  <layout-center class="app-head">
    <el-row>
      <el-col :span="6">
        <img class="app-logo" src="@/assets/logo/bzzy-logo.svg"/>
      </el-col>

      <el-col :span="18" style="text-align: right; z-index: 998;">
        <ul class="app-head-navigation">
          <li v-for="nav in navList" :key="nav" @mouseover="mouseover(nav.path)" @mouseleave="mouseLeave()"
              @click="navActive(nav)">
            <div @click="loadModule(nav)">
              {{ nav.name }}
              <img v-if="nav.icon !== undefined && nav.path !== mousePath" :src="nav.icon">
              <img v-if="nav.icon !== undefined && nav.path === mousePath" src="@/assets/images/index/head/up.svg">
              <div v-show="nav.path === activePath" class="nav-title-active"></div>
            </div>
            <div class="app-head-navigation-item" :style="{'left': '-' + (nav.children.length - 1) * 40 + '%'}">
              <div v-for="navItem in nav.children" :key="navItem" v-show="nav.path === mousePath">
                <img :src="navItem.icon"/>

                <div @click="loadModule(navItem)">{{ navItem.name }} <img src="@/assets/images/pathRight.svg"/></div>
                <ul>
                  <li v-for="navChildren in navItem.children" :key="navChildren" @click="loadModule(navChildren)">
                    {{ navChildren.name }}
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </el-col>
    </el-row>
  </layout-center>
</template>

<script>
import { useRouter } from 'vue-router'
import {ref} from "vue"
import {navList} from "@/layout/components/AppHead/data"
import {getProductTypeList} from "@/api/product"
import {getSolutionTypeList} from "@/api/solution"

const {watch} = require("vue")

export default {
  name: 'AppHead',
  setup(props, context) {
    const router = useRouter()

    let activePath = ref('index')
    watch(() => router.currentRoute.value.path,(toPath) => {
      activePath.value = toPath
    },{immediate: true,deep: true})

    let mousePath = ref(null)
    const mouseover = (d) => {
      if (d != null) {
        mousePath.value = d
      }
    }

    const mouseLeave = () => {
      mousePath.value = null
    }

    const loadModule = (e) => {
      mousePath.value = null
      context.emit('loadModule', e)
    }

    const navActive = (e) => {
      activePath.value = e.path
    }

    getSolutionTypeList().then(response => {
      response.forEach((e)=> {
        if(e.parentId === '0') {
          e.type = 'classify'
        }
      })
      navList[1].children = response
    })

    getProductTypeList().then(response => {
      navList[2].children = response
    })

    return {
      navList,
      mousePath,
      mouseover,
      mouseLeave,
      loadModule,
      navActive,
      activePath
    }
  }
}

</script>

<style scoped>
.app-head {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 998;
  background-color: #ffffff;
}

.app-head > div > div {
  height: 70px;
  line-height: 70px;
}

.app-logo {
  width: auto;
  height: 44px;
  position: relative;
  top: 13px;
}

.app-head-navigation {
  width: 100%;
  cursor: pointer;
  float: right;
}

.app-head-navigation > li {
  padding: 0 20px 0 20px;
  font-family: PingFangSC-Medium;
  color: #222222;
  letter-spacing: 0;
  position: relative;
}

.app-head-navigation > li > div:nth-child(1):hover {
  color: #409EFF;
}

.app-head-navigation > li > div > div > div {
  font-weight: 600;
}

.app-head-navigation > li > div > div > ul {
  font-family: PingFangSC-Regular;
  color: #313131;
}

.app-head-navigation > li > div > div > ul > li:hover {
  color: #409EFF;
}

.app-head-navigation-item {
  background-color: #ffffff;
  box-shadow: 0 0 10px 0 #e8e7e7;
  border-radius: 5px;
  text-align: left;
  position: absolute;
  top: 60px;
  white-space: nowrap;
  padding: 0 20px 0 20px;
  z-index: 997;
}

.app-head-navigation-item > div {
  padding: 0 15px 0 15px;
  font-size: 15px;
  font-weight: 300;
  display: inline-block;
  vertical-align: top;
}

.app-head-navigation-item > div > img:nth-child(1) {
  display: block;
  position: relative;
  top: 15px;
  width: 22px;
  height: 23px;
}

.app-head-navigation-item > div > div {
  border-bottom: 1px solid #e8e7e7;
  display: inline-block;
  line-height: 45px;
}

.app-head-navigation-item > div > ul > li {
  display: block;
  line-height: 45px;
}

.nav-title-active {
  width: 50%;
  height: 3px;
  border-radius: 5px;
  background: #409EFF;
  position: relative;
  top: -5px;
  margin: 0 auto;
}
</style>
